import React, { useEffect, useState } from 'react'
import Button from '../../atoms/Button/Button'
import { Trans } from '../../atoms'
import NewModal from '../../molecules/NewModal/NewModal'
import useTrans from '../../../hooks/useTrans'
import { api } from '../../../utils'
import FormCheckbox from '../../atoms/FormCheckbox/FormCheckbox'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

const CartPopup = ({
  show,
  closePopup,
  AddToLater_All,
  content,
  handleMultiCheckout,
  steps,
  svuotaCarrelloMain,
}) => {
  const t = useTrans()
  const router = useRouter()
  const service_gift = useSelector((state) => state.servicegift?.service_gift)
  const [checked, setChecked] = useState(true)
  const [checkoutMultiplo, SetCheckoutMultiplo] = useState(false)
  const _getModalParams = () => {
    switch (content) {
      case 'quantita_minima_personalizzabile':
        return {
          title: t('Quantità minime personalizzabili non rispettate'),
          text: (
            <>
              <p>
                <Trans chiave="Per continuare è necessario modificare le quantità" />
              </p>
              <p></p>
            </>
          ),
          actions: [
            <Button
              label={t('Procedi')}
              variant="primary"
              onClick={() => closePopup()}
              size="medium"
              key="cart-popup-btn1"
            />,
          ],
        }
      case 'checkout_sospeso':
        return {
          title: t('Hai un Checkout in sospeso'),
          text: (
            <>
              <p>{t('Vuoi continuare?')}</p>
              {steps.map((step, key) => (
                <p
                  style={{ textDecoration: step?.processato === true ? 'line-through' : null }}
                  key={key}
                >
                  <strong> Checkout {step.step}</strong> {step.step_label}
                </p>
              ))}
            </>
          ),
          actions: [
            <Button
              label={t('Elimina checkout in sospeso')}
              variant="secondary"
              size="large"
              onClick={() => {
                api
                  .delete('carrelli/checkout/')
                  .then(() => router?.reload())
                  .catch((err) => {
                    console.log(err)
                    router?.reload()
                    closePopup()
                  })
              }}
              key="cart-popup-btn1"
            />,
            <Button
              label={t('Procedi')}
              variant="primary"
              size="large"
              onClick={() => {
                handleMultiCheckout && handleMultiCheckout(steps)
              }}
              key="cart-popup-btn2"
            />,
          ],
        }
      case 'loghi':
        return {
          title: t('Loghi mancanti da applicare'),
          text: (
            <>
              <p>
                <Trans chiave="Per continuare è necessario caricare i loghi mancanti" />
              </p>
              <p>
                <Trans chiave="............................" />
              </p>
            </>
          ),
          actions: [
            <Button
              label={t('Annulla')}
              variant="secondary"
              onClick={() => closePopup()}
              size="medium"
              key="cart-popup-btn1"
            />,
            <Button
              label={t('Conferma Loghi')}
              variant="primary"
              onClick={() => closePopup()}
              size="medium"
              key="cart-popup-btn2"
            />,
          ],
        }
      case 'merce_mista':
        // step_name POSSIBILI:
        // personalizzato_prenotazione
        // personalizzato
        // neutro_prenotazione
        // neutro
        const con_prenotata =
          steps?.filter(
            (step) =>
              step?.step_name === 'personalizzato_prenotazione' ||
              step?.step_name === 'neutro_prenotazione'
          )?.length > 0
        const con_personalizzata =
          steps?.filter(
            (step) =>
              step?.step_name === 'personalizzato_prenotazione' ||
              step?.step_name === 'personalizzato'
          )?.length > 0
        const con_neutra =
          steps?.filter(
            (step) => step?.step_name === 'neutro_prenotazione' || step?.step_name === 'neutro'
          )?.length > 0

        let title = 'Merce mista'

        if (con_prenotata && con_neutra && !con_personalizzata) {
          title = t("L'ordine contiene sia merce disponibile che prenotazioni di merce") // neutra e prenotata
        }
        if (con_neutra && con_personalizzata && !con_prenotata) {
          title = service_gift
            ? t("Procedi all'acquisto della merce neutra e personalizzata")
            : t("L'ordine contiene sia merce neutra che personalizzata") // neutra e personalizzata
        }
        if (!con_neutra && con_personalizzata && con_prenotata) {
          title = t(
            "L'ordine contiene sia merce personalizzata disponibile che prenotazione di merce"
          ) // personalizata e prenotata
        }
        if (con_neutra && con_personalizzata && con_prenotata) {
          title = t("L'ordine contiene merce neutra, merce personalizzata e prenotazione di merce") // neutra e prenotata e personalizzata
        }

        return {
          title: title,
          text: (
            <>
              {service_gift ? (
                <p>
                  {t(
                    'Al termine del primo checkout sarà possibile proseguire con il checkout successivo'
                  )}
                </p>
              ) : (
                <>
                  <p>
                    {t('Non è possibile inviare un unico ordine con queste differenti casistiche.')}
                  </p>
                  <p>
                    {t(
                      'Al termine del primo checkout sarà possibile proseguire con i checkout successivi'
                    )}
                  </p>
                </>
              )}

              {steps.map((step, key) => (
                <p key={key}>
                  <strong>
                    {t('Checkout')} {step.step}
                  </strong>{' '}
                  {t(step.step_label)}
                </p>
              ))}

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 25,
                }}
              >
                <FormCheckbox
                  onChange={(e) => setChecked(e.target.checked)}
                  checked={checked}
                  labelHtml={
                    service_gift
                      ? t(
                          "<strong>Utilizza i dati di consegna e fatturazione</strong> per entrambi i checkout per procedere in modo più veloce all'acquisto"
                        )
                      : t('Utilizza i dati di spedizione per tutti i checkout')
                  }
                />
              </div>
            </>
          ),
          actions: [
            ...(service_gift
              ? []
              : [
                  <Button
                    label={t('Salva per dopo')}
                    variant="secondary"
                    disabled={checkoutMultiplo}
                    size="large"
                    onClick={() => {
                      AddToLater_All && AddToLater_All(), closePopup()
                    }}
                    key="cart-popup-btn1"
                  />,
                ]),
            <Button
              label={service_gift ? t("Procedi all'acquisto") : t('Procedi')}
              variant="primary"
              disabled={checkoutMultiplo}
              size="large"
              onClick={() => {
                SetCheckoutMultiplo(true)
                api
                  .post('carrelli/main/gotocheckout/', {
                    save_dati: checked,
                  })
                  .then((res) => handleMultiCheckout && handleMultiCheckout(res?.data.steps))
                  .catch((err) => console.log(err))
              }}
              key="cart-popup-btn2"
            />,
          ],
          onClose: () => closePopup(),
        }

      case 'blocco_utente':
        return {
          alert: true,
          // title: !service_gift ? t('Attenzione problemi di Pagamento') : t("Non è possibile procedere con l'ordine."),
          title: t("Non è possibile procedere con l'ordine."),
          text: (
            <>
              {/* {!service_gift && (
                <p>
                  <Trans chiave="Non è possibile procedere con l'ordine." />
                </p>
              )} */}
              {!service_gift ? (
                <p>
                  <Trans chiave="Ti preghiamo di contattare l'amministrazione." />
                </p>
              ) : (
                <p>
                  <Trans chiave="Contattaci per chiarimenti." />
                </p>
              )}
            </>
          ),
          actions: [
            <Button
              label={t('Chiudi')}
              variant="primary"
              onClick={() => closePopup()}
              size="large"
              key="cart-popup-btn1"
            />,
          ],
        }
      case 'clean_carrello':
        return {
          alert: true,
          title: t('Attenzione problema con il carrello'),
          text: (
            <>
              <p>
                <Trans chiave="La merce nel carrello contiene dei problemi ti chiediamo di svuotarlo" />
              </p>
              <p>
                <Trans chiave="Ci scusiamo per l'errore" />
              </p>
            </>
          ),
          actions: [
            <Button
              label={t('Chiudi')}
              variant="secondary"
              onClick={() => closePopup()}
              size="large"
              key="cart-popup-btn1"
            />,
            <Button
              label={t('Svuota carrello')}
              variant="primary"
              onClick={() => svuotaCarrelloMain()}
              size="large"
              key="cart-popup-btn2"
            />,
          ],
        }
      default:
        break
    }
  }

  return <NewModal visible={show} {..._getModalParams()} />
}

export default CartPopup

export const ContinuaCheckout = () => {
  return <NewModal visible={true}></NewModal>
}
